import http from './http'
import store from '@/store/index'

function getDataRecursive (url: any, retrievedItems: any, i: any, iterations: any, resolve: any, reject: any) {
  if (i <= iterations) {
    let pageUrl = url + '&page=' + (i)
    http.get(pageUrl)
      .then(response => {
        retrievedItems = retrievedItems.concat(response.data.data)
        store.commit('categories/addToItems', response.data.data)
        getDataRecursive(url, retrievedItems, (i + 1), iterations, resolve, reject)
      }).catch(error => {
        console.log(error)
        reject('Something wrong. Please refresh the page and try again.')
      })
  } else {
    resolve(retrievedItems)
  }
}

export const getAllData = (route: any, options: any, limit: any, resolve: any, reject: any) => {
  // Build URL for specified option and limit
  let url = route + '?limit=' + limit

  options.forEach(function (option: any) {
    url = url + '&' + option
  })

  let retrievedItems: any = []

  http.get(url)
    .then(response => {
      // retrievedItems = retrievedItems.concat(response.data.data)
      store.commit('categories/addToItems', response.data.data)
      retrievedItems = retrievedItems.concat(response.data.data)

      // Compute iterations from total and limit to get all data
      let iterations = Math.ceil(response.data.total / limit)
      let i = 2

      new Promise((resolve, reject) => {
        getDataRecursive(url, retrievedItems, i, iterations, resolve, reject)
      }).then(response => {
        resolve(response)
      }
      )
    })
    .catch(error => {
      console.log(error)
      reject('Something wrong. Please refresh the page and try again.')
    })
}
